<script lang="ts">
	import { Sun, Moon } from 'lucide-svelte';
	import { theme } from '$lib/stores/theme';

	function toggleTheme() {
		theme.update((current) => (current === 'light' ? 'dark' : 'light'));
	}
</script>

<button
	on:click={toggleTheme}
	class="rounded-lg p-2 transition-colors hover:bg-gray-200 dark:hover:bg-gray-700"
	aria-label="Toggle theme"
>
	{#if $theme === 'light'}
		<Moon class="h-5 w-5" />
	{:else}
		<Sun class="h-5 w-5" />
	{/if}
</button>
